import axios from 'axios';

export const {REACT_APP_API_URL} = process.env;
axios.defaults.baseURL = REACT_APP_API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

export default axios;
